import React, {Suspense, useContext, useEffect, useState} from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes } from 'react-router-dom'
import { SWRConfig } from 'swr'
import Admin from './Admin/Admin'
import './App.css'
import Footer from './components/Footer'
import Header from './components/Navbar/Header'
import ScrollToTop from './components/ScrollToTop'
import ShabbatClosure from './components/ShabbatClosure'
import DonationPage from './components/TempPopup'
import DonationPopup from './components/WelcomePopup'
import { FamilyContext } from './Context/FamilyHeadContext'
import About from './pages/About'
import Essays from './pages/Essays/Essays'
import FamilyIndex from './pages/FamilyIndex/FamilyIndex'
import MainFamilyTreeComponent from './pages/FamilyTree/MainFamilyTreeComponent'
import Forum from './pages/Forum'
import GenerationCount from './pages/GenerationCount'
import Home from './pages/Home'
import LoginPage from './pages/LoginPage'
import Page404 from './pages/Page404'
import ResultsPage from './pages/Search/ResultsPage'
import { doApiGet } from './services/apiService'
import LanguageWrapper from './translations/LanguageWrapper'

// Lazy loading של PersonDetails
const PersonDetails = React.lazy(() =>
  import('./pages/PersonDetailes/PersonDetailes'),
)

// Loading component
export const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen font-heebo">
    <div className="w-8 h-8 border-4 border-[#937c5d] border-r-transparent rounded-full animate-spin"></div>
  </div>
)

function App() {
  const { pathPrefix, isAuthenticated } = useContext(FamilyContext)
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const [direction, setDirection] = useState('rtl');

  const getDirection = () => {
    return pathPrefix.includes('/he/') ? 'rtl' : 'ltr'
  }

  useEffect(() => {
    document.title = t('html.title')
    document.documentElement.dir = direction
    document.documentElement.lang = currentLanguage
  }, [currentLanguage, direction])

  return (
      <div dir={getDirection()}>
        <SWRConfig value={{fetcher: doApiGet}}>
          <ShabbatClosure forceShabbat={false}/>
          <Header/>
          <DonationPopup/>
          <main className="min-h-screen">
            <Routes>
              <Route path={'/'} element={<LanguageWrapper/>}/>
              <Route path={`${pathPrefix}`} element={<Home/>}/>
              <Route
                  path={`${pathPrefix}donationPage`}
                  element={<DonationPage/>}
              />
              {/* Temp page */}
              <Route path={`${pathPrefix}forum`} element={<Forum/>}/>
              <Route path={`${pathPrefix}about`} element={<About/>}/>
              <Route path={`${pathPrefix}essays`} element={<Essays/>}/>
              <Route
                  path={`${pathPrefix}descendants/:gedId/:generation/:familyType`}
                  element={<GenerationCount/>}
              />
              <Route
                  path={`${pathPrefix}admin`}
                  element={isAuthenticated ? <Admin/> : <LoginPage/>}
              />
              <Route path={`${pathPrefix}login`} element={<LoginPage/>}/>
              <Route
                  path={`${pathPrefix}results-page`}
                  element={<ResultsPage/>}
              />
              <Route
                  path={`${pathPrefix}family-index`}
                  element={<FamilyIndex/>}
              />
              <Route
                  path={`${pathPrefix}person/:id`}
                  element={
                    <Suspense fallback={<LoadingFallback/>}>
                      <PersonDetails/>
                    </Suspense>
                  }
              />
              <Route
                  path={`${pathPrefix}familyTree`}
                  element={<MainFamilyTreeComponent/>}
              />
              <Route path={`*`} element={<Page404/>}/>

            </Routes>
          </main>

          <ScrollToTop/>
          <Footer/>
        </SWRConfig>
      </div>
  )
}

export default App
